export enum QuestStatus {
    NotStarted = 0,
    InProgress = 1,
    Completed = 2,
    Error = 3,
}
